import {FormControl} from "@luciad/ria-sample-common/components/FormControl";
import {IToastContext} from "@luciad/ria-sample-common/hooks/useToast";
import {LayerTreeNode} from "@luciad/ria/view/LayerTreeNode";
import {Map} from "@luciad/ria/view/Map";
import React, {ChangeEvent, useState} from "react";
import {addLayer} from "../DataFormatsUtil";
import {ConnectToURLPage} from "./ConnectToURLPage";
import "./ConnectToURLWithQualityPage.css";

interface Props {
  onPrevious: () => void;
  onReset: () => void;
  onCreateLayer: (url: string, quality: number, logInfo: (message: string) => void) => Promise<LayerTreeNode>;
  defaultURL: string;
}

export const ConnectToURLWithQualityPage = ({onPrevious, onReset, onCreateLayer, defaultURL}: Props) => {
  const [qualityFactor, setQualityFactor] = useState<number>(0.5);

  const handleQualityFactorChange = (ev: ChangeEvent<HTMLInputElement>) => {
    setQualityFactor(parseFloat(ev.target.value));
  }

  const handleSubmit = (url: string, map: Map, toastContext: IToastContext) => {
    onCreateLayer(url, qualityFactor, toastContext.showInfoToast).then(layer => {
      return addLayer(map, layer).then(onReset);
    }).catch(error => {
      toastContext.showErrorToast(error.message, error);
      onReset();
    });
  }

  let qualityText = "Fast";
  if (qualityFactor > 0.7) {
    qualityText = "Accurate";
  } else if (qualityFactor > 0.4) {
    qualityText = "Normal";
  }

  return (
      <ConnectToURLPage onSubmit={handleSubmit} onPrevious={onPrevious} defaultValue={defaultURL}>
        <FormControl>
          <label htmlFor="qualityFactor">Quality</label>
          <div className="quality-slider-with-info">
            <input type="range"
                   min={0.2}
                   max={1.0}
                   step={0.1}
                   name="qualityFactor"
                   value={qualityFactor}
                   onChange={handleQualityFactorChange}
            />
            <div className="qualityInfo">
              <span>{qualityText}</span>
            </div>
          </div>
        </FormControl>
      </ConnectToURLPage>
  )

}